// Types
// Components
import Content from '@/components/composite/FirstStats/Content';
import type { StartButtonBlockProps } from '@/components/composite/FirstStats/Content/StartButtonBlock';

type FirstStatsProps = Pick<StartButtonBlockProps, 'start'>;

const FirstStats = ({ start }: FirstStatsProps) => {
    return <Content start={start} />;
};

export default FirstStats;
